import {NetworkEnums} from '../../../../shared/GameEnums'
import {MatchmakingCancelReason} from '../../../../shared/matchmaking/MatchmakingEnums'
import {MatchmakingRequest} from '../../../../shared/matchmaking/MatchmakingInterfaces'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'
import {socket} from '../EntryShared'
import {MatchmakingAction, PRIMARY_MATCHMAKING_ACTIONS} from '@colonist/lobby-types'
import {ClientMessageSubType} from '@colonist/types'
import SendMatchmakingActionData = NetworkEnums.SendMatchmakingActionData

export class SocketMatchmakingSend {
    static lastMatchmakingRequest: MatchmakingRequest | undefined

    private static send(action: MatchmakingAction, data: any) {
        const actionDataToSend: SendMatchmakingActionData = {
            action: action,
            payload: data,
        }
        socket.controller.sender.sendToServerType(ClientMessageSubType.MatchmakingAction, 'lobby', actionDataToSend, PRIMARY_MATCHMAKING_ACTIONS.includes(action))
    }

    static sendFindGame() {
        if(!this.lastMatchmakingRequest) return
        this.send(MatchmakingAction.ClickedFindGame, this.lastMatchmakingRequest)
    }

    static enterMatchmaker(matchmakingRequest: MatchmakingRequest) {
        this.lastMatchmakingRequest = matchmakingRequest
        void UIGameSpriteHandler.continueAfterAssetsLoad(() => {
            this.sendFindGame()
        })
    }

    static sendCancelFindGame(reason: MatchmakingCancelReason) {
        this.lastMatchmakingRequest = undefined
        this.send(MatchmakingAction.ClickedCancelFindGame, reason)
    }

    static finishedWatchingPreRollAdForRankedGameEntry() {
        this.send(MatchmakingAction.FinishedWatchingPreRollAdForRankedGameEntry, true)
    }
}
